/* global graphql  */
import React from 'react'
import Helmet from 'react-helmet'
import Header from '../components/header-new'
import Footer from '../components/footer-new'

const PrivacyPage = ({ data }) => (
  <div className='wrapper--page'>
    <Helmet title='Privacy Policy - ATTN:' />
    <Header />
    <div className='cms-page wrapper--max-width'>
      <h1>{data.drupalPage.title}</h1>
      <div dangerouslySetInnerHTML={{ __html: data.drupalPage.body.value }} />
      <hr className='cms-page__spacer' />
    </div>
    <Footer />
  </div>
)

export default PrivacyPage

export const query = graphql`
  query PrivacyQuery {
    drupalPage(nid: {eq: "11"}) {
      nid
      title
      body {
        value
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/privacy.js